export enum StoreEvent {
    RecordAdded = 0,
    RecordRemoved = 1,
    RecordUpdated = 2,
    CommitComplete = 3,
    RollbackComplete = 4
}
